import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material';
import { Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import {
  downloadMultipleFiles,
  formatDate,
  getFromToDates,
  replaceLetterOWithW,
} from '../../utils/utilityFunctions';
import { getInvestorReports } from '../../redux-store/actions/investorReports';
import { BpRadio, ReportSectionContainer, ReportsRightLayout } from './index';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import { MFSubmitButton } from '../../lib/formik';
import { validationSchemaCgStatement } from '../../utils/schema';
import { Location } from 'history';
import { useHistory } from 'react-router';
import { DayJsDatePicker } from '../onboarding/newDatePicker';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useState } from 'react';
//! Radio Options
const options = [
  { label: 'Previous FY', value: 'previous-fy' },
  { label: 'Current FY', value: 'current-fy' },
  { label: 'Custom Date', value: 'custom' },
];

const CGStatement = ({
  location
}: {
  location: Location<{ investorId: string; investorName: string }>
}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { investorId, investorName } = location?.state || { investorId: '', investorName: '' };
  const currentDate = dayjs();
  const [dates, setDates] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));
  const [dates1, setDates1] = useState<string>(dayjs(currentDate).format("YYYY-MM-DD"));
  const [loading, setLoading] = useState<boolean>(false)

  const getFormattedFromDate = (date: any, duration: string) => {
    const month = new Date(date)?.getMonth() + 1;
    const year = new Date(date)?.getFullYear();
    if (duration === 'current-fy') {
      if (month >= 4) {
        const finalDate = `01/04/${year}`
        return finalDate;
      } else {
        const finalDate = `01/04/${year - 1}`
        return finalDate;
      }
    } else if (duration === 'previous-fy') {
      if (month >= 4) {
        const finalDate = `01/04/${year - 1}`
        return finalDate;
      } else {
        const finalDate = `01/04/${year - 2}`
        return finalDate;
      }
    }
  }
  const getFormattedToDate = (date: any) => {
    const month = new Date(date)?.getMonth() + 1;
    const year = new Date(date)?.getFullYear();
    if (month >= 4) {
      const finalDate = `31/03/${year}`
      return finalDate;
    } else {
      const finalDate = `31/03/${year - 1}`
      return finalDate;
    }

  }

  const onSubmit = async (values: any) => {
    try {
      const { fileType, fromDate, toDate, duration } = values;
      const FromDate = `${new Date(fromDate).getDate().toString().padStart(2, '0')}/${(new Date(fromDate)?.getMonth() + 1).toString().padStart(2, '0')}/${new Date(fromDate).getFullYear()}`;
      const ToDate = `${new Date(toDate).getDate().toString().padStart(2, '0')}/${(new Date(toDate)?.getMonth() + 1).toString().padStart(2, '0')}/${new Date(toDate).getFullYear()}`;

      if (investorId) {
        setLoading(true)
        const res = await dispatch(
          getInvestorReports({
            reportName: 'CgStatement',
            // clientId: [replaceLetterOWithW(investorId) || ''],
            clientId: [investorId || ''],
            fileType,
            fromDate: duration === 'custom' ? FromDate : getFormattedFromDate(fromDate, duration),
            toDate: duration === 'previous-fy' ? getFormattedToDate(toDate) : ToDate,
          })
        );
        downloadMultipleFiles(res);
        enqueueSnackbar('File(s) downloaded successfully.', {
          variant: 'success',
          autoHideDuration: 3000,
        });
        setLoading(false)
      }
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <ReportsRightLayout>
      <Typography
        sx={{
          color: 'text.secondary',
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: '19px',
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          display: ['none', 'none', 'block'],
        }}>
        CG Statement
      </Typography>

      <Formik
        validationSchema={validationSchemaCgStatement}
        initialValues={{
          duration: options[0].value,
          fromDate: new Date(),
          toDate: new Date(),
          fileType: 'pdf',
        }}
        onSubmit={onSubmit}>
        {({ values, setFieldValue }) => (
          <Form>

            <ReportSectionContainer>
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '22px',
                  letterSpacing: '0.01em',
                  pt: 1,
                  pb: 1,
                }}>
                Choose duration of statement -
              </Typography>
              <Box>
                <FormControl sx={{ width: '100%' }}>
                  <RadioGroup
                    name={'duration'}
                    value={values.duration}
                    onChange={(event) => {
                      setFieldValue('duration', event.currentTarget.value);
                    }}
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: ['1fr 1fr', '1fr 1fr 1fr'],
                      gridColumnGap: 8,
                      gridRowGap: '1rem',
                    }}>
                    {options.map(({ label, value }) => (
                      <FormControlLabel
                        key={value}
                        value={value}
                        control={<BpRadio />}
                        label={label}
                      />
                    ))}
                  </RadioGroup>
                  {values.duration === 'custom' && (
                    <>
                      {/* <TextDatePicker
                        label={'From Date'}
                        inputLabelStyles={{
                          transform: 'unset',
                          fontSize: 14,
                          fontWeight: 500,
                          color: 'rgba(0,0,0,0.7)',
                        }}
                        applyLabelStyles={true}
                        placeholder={'Enter Net worth as on Date'}
                        name={`fromDate`}
                      /> */}
                      <Stack
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}
                        >

                          <DatePicker
                            sx={{
                              my: "30px"
                            }}
                            label="From Date"
                            format="DD-MM-YYYY"
                            value={dayjs(dates)}
                            maxDate={dayjs(currentDate)}

                            onChange={(date: any) => {
                              setDates(date.format("YYYY-MM-DD"))
                              setFieldValue('fromDate', date)
                            }
                            }
                          />

                        </LocalizationProvider>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>

                          <DatePicker
                            label="To Date"
                            format="DD-MM-YYYY"
                            value={dayjs(dates1)}
                            maxDate={dayjs(currentDate)}

                            onChange={(date: any) => {
                              setDates1(date.format("YYYY-MM-DD"))
                              setFieldValue('toDate', date)
                            }
                            }
                          />

                        </LocalizationProvider>
                      </Stack>
                      {/* <TextDatePicker
                        label={'To Date'}
                        inputLabelStyles={{
                          transform: 'unset',
                          fontSize: 14,
                          fontWeight: 500,
                          color: 'rgba(0,0,0,0.7)',
                        }}
                        applyLabelStyles={true}
                        placeholder={'Enter Net worth as on Date'}
                        name={`toDate`}
                      /> */}

                    </>
                  )}
                </FormControl>
              </Box>
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '22px',
                  letterSpacing: '0.01em',
                  pt: 2,
                  pb: 1,
                }}>
                Report download options
              </Typography>

              <FormControl>
                <RadioGroup
                  name={'fileType'}
                  value={values.fileType}
                  onChange={(event) => {
                    setFieldValue('fileType', event.currentTarget.value);
                  }}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 1,
                  }}>
                  <FormControlLabel value="pdf" control={<BpRadio />} label="PDF" />
                  <FormControlLabel value="xlsx" control={<BpRadio />} label="Excel" />
                </RadioGroup>
              </FormControl>
            </ReportSectionContainer>
            <Stack justifyContent="center" alignItems="center" sx={{ m: 2 }}>
              <MFSubmitButton
                label="Download"
                loadingEnable={loading}
              // disabled={selectedFamilyMembers[0] === 'overall-family'}
              />
            </Stack>
          </Form>
        )}
      </Formik>
    </ReportsRightLayout>
  );
};

export default CGStatement;
